/**
 * Display wording for a location type. Presentation only — nothing branches
 * on it, and a type the map does not know (wind sites, say) falls back to
 * wording derived from the type's own name, so a new type needs no code.
 */

export type LocationTypeCopy = {
  /** Section heading. */
  section: string
  /** Table header for the name column. */
  header: string
  /** "Add ___" button. */
  add: string
  /** Dialog eyebrow for a new location. */
  newTitle: string
  /** Dialog eyebrow for an existing one. */
  editTitle: string
  /** Name field label. */
  nameLabel: string
  namePlaceholder: string
  /** Save button for a new location. */
  save: string
  empty: string
  untitled: string
}

const KNOWN: Record<string, LocationTypeCopy> = {
  Yard: {
    section: 'Laydown yards',
    header: 'Yard',
    add: 'Add yard',
    newTitle: 'New laydown yard',
    editTitle: 'Edit yard',
    nameLabel: 'Yard name',
    namePlaceholder: 'e.g. Yard A',
    save: 'Save yard',
    empty: 'No laydown yards set up for this project yet.',
    untitled: 'Untitled yard',
  },
  'Power Block': {
    section: 'Power blocks',
    header: 'Block',
    add: 'Add block',
    newTitle: 'New block',
    editTitle: 'Edit block',
    nameLabel: 'Block name',
    namePlaceholder: 'e.g. Block 12',
    save: 'Save block',
    empty: 'No power blocks set up for this project yet.',
    untitled: 'Untitled block',
  },
}

export function locationTypeCopy(typeName: string): LocationTypeCopy {
  const known = KNOWN[typeName]
  if (known) return known

  const lower = typeName.toLowerCase()
  return {
    section: `${typeName}s`,
    header: typeName,
    add: `Add ${lower}`,
    newTitle: `New ${lower}`,
    editTitle: `Edit ${lower}`,
    nameLabel: `${typeName} name`,
    namePlaceholder: '',
    save: `Save ${lower}`,
    empty: `No ${lower}s set up for this project yet.`,
    untitled: `Untitled ${lower}`,
  }
}
